import GraphQLAPI from "@aws-amplify/api-graphql";
import { Icon, Spinner } from "@goodfill/ui-components";
import { graphqlOperation } from "aws-amplify";
import { useCallback, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { PricedBond } from "../PricedBond";
import { isGlobalFavoriteBondLoading, userDataState, userFavoriteBondsState } from "../../../state";
import { UpdateUserInput, updateUser } from "@goodfill/models-typescript";
import { toggleInArray } from "@goodfill/array";
import { toastErrorHandler } from "../../../unexpectedErrorHandler";
import { SvgIconProps } from "../../../ui-components/SvgIcon";

export const FavorBond = ({
  pricedBond,
  size,
  className,
}: { pricedBond: PricedBond; size?: SvgIconProps["size"]; className?: string }) => {
  const userData = useRecoilValue(userDataState);
  const userId = userData?.userId;
  const bondId = pricedBond.bondIdCusip;
  const [userFavoriteBondsData, setUserFavoriteBondsData] = useRecoilState(userFavoriteBondsState);

  const [isGlobalLoading, setIsGlobalLoading] = useRecoilState(isGlobalFavoriteBondLoading);

  const [isLoading, setIsLoading] = useState(false);

  const toggleBondFavorite = useCallback(async () => {
    if (isGlobalLoading || isLoading || userId === null) {
      return;
    }

    setIsLoading(true);
    setIsGlobalLoading(true);
    try {
      const nextFavoriteBonds = toggleInArray(bondId, userFavoriteBondsData);
      const input: UpdateUserInput = {
        id: `${userId}`,
        favoriteBonds: nextFavoriteBonds.map((a) => `${a}`),
      };
      const operation = graphqlOperation(updateUser, { input });
      await GraphQLAPI.graphql(operation);

      setUserFavoriteBondsData(nextFavoriteBonds);
    } catch (e) {
      toastErrorHandler(e);
    } finally {
      setIsLoading(false);
      setIsGlobalLoading(false);
    }
  }, [
    userId,
    bondId,
    isLoading,
    setUserFavoriteBondsData,
    userFavoriteBondsData,
    isGlobalLoading,
    setIsGlobalLoading,
  ]);

  if (isLoading) {
    return <Spinner size={size !== undefined ? size : 15} />;
  }

  const isFavorite = userFavoriteBondsData.includes(bondId);

  return (
    <Icon
      className={className}
      fill={isGlobalLoading ? "gray" : undefined}
      size={size !== undefined ? size : 15}
      style={{ marginBottom: "0.2rem" }}
      disabled={isGlobalLoading}
      name={isFavorite ? "star" : "star-empty"}
      onClick={toggleBondFavorite}
    />
  );
};
